import { Component, Prop, h } from '@stencil/core';
import { OrderInfoRow } from '../../utils/models';


@Component({
  tag: 'tambr-checkout-order-info',
  styleUrl: 'tambr-checkout-order-info.css',
  shadow: true,
})
export class TambrCheckoutOrderInfo {

  @Prop() orderInfo: OrderInfoRow[];

  renderRow( label: string, value: string, cssClass: string = '' ) {
    if ( !value ) return;
    return( 
      <div class={ 'order-details-row ' + cssClass }>
        <div class='order-details-label'>{ label }</div> 
        <div class='order-details-value'>{ value }</div>
      </div>
    );
  }

  render() {
    return (  
      <div class='order-details'>
        {( this.orderInfo?.map( line => this.renderRow( line.label, line.value, line.cssClass ) ) ) }
      </div>
    );
  }

}